import { useState as c, useRef as n, useEffect as a } from "react";
const f = 650, L = (e, o = f) => {
  const [u, t] = c(e), r = n(), s = () => {
    r.current && clearTimeout(r.current), t(!1);
  };
  return a(() => (e ? r.current = setTimeout(() => {
    t(!0);
  }, o) : s(), () => {
    s();
  }), [o, e]), {
    isLoading: u,
    setIsLoading: t
  };
};
export {
  L as useLoadingDelay
};
